import type { FiatCurrency } from '@0xtorch/core'
import { and, eq, inArray, isNotNull, isNull, lte, notLike } from 'drizzle-orm'
import { parseToAction } from '../../parsers/action'
import { actionTable, actionTransferTable } from '../../schema'
import type { DatabaseWithTransaction } from '../../types'

type SelectNullCryptoPriceActionsParameters = {
  before?: number
  database: DatabaseWithTransaction
  fiats: FiatCurrency[]
}

/** asset が coingecko に listing されている crypto で、 price = null な Action Transfer を含む action を一括取得
 * - before が設定されている場合は action.timestamp <= before のものに限定する
 */
export const selectNullCryptoPriceActions = async ({
  before,
  database: { database },
  fiats,
}: SelectNullCryptoPriceActionsParameters) => {
  // price = null , asset = coingecko listing crypto の Action Transfer の actionId 取得
  const actionIdRows = await database
    .selectDistinct({ actionId: actionTransferTable.actionId })
    .from(actionTransferTable)
    .leftJoin(actionTable, eq(actionTransferTable.actionId, actionTable.id))
    .where(
      and(
        ...(before ? [lte(actionTable.timestamp, new Date(before))] : []),
        isNull(actionTransferTable.price),
        isNotNull(actionTransferTable.cryptoId),
        notLike(actionTransferTable.cryptoId, '0xtorch-%'),
        notLike(actionTransferTable.cryptoId, 'evm_%'),
        notLike(actionTransferTable.cryptoId, 'solana_%'),
      ),
    )
  const actionIds = actionIdRows.map((row) => row.actionId)

  // action 関連 row データ取得して Action オブジェクトに変換して返す
  const result = await database.query.actionTable.findMany({
    where: inArray(actionTable.id, actionIds),
    with: {
      actionTransferTable: {
        with: {
          cryptoCurrencyTable: true,
          nftTable: true,
        },
      },
      nftTable: true,
    },
  })
  return result.map((data) => parseToAction(data, fiats))
}
